<template>
  <button
    :disabled="$store.state.loading"
    class="mt-3 border-2 text-blue-700 border-blue-700 active:bg-blue-600 text-gray-100 font-bold py-2 px-4 rounded focus:outline-none disabled:cursor-not-allowed disabled:opacity-75"
    type="button"
    @click.stop="logout()">
    Keluar
  </button>
</template>

<script>
export default {
  props: [],
  mounted() {
    this.$nextTick(function () {
    })
  },
  methods: {
    async logout() {
      try {
        this.$store.commit('setLoading', true);
        await axios.post('/logout');
        window.location.reload();
      } catch (error) {
        this.$store.commit('setLoading', false);
        throw error;
      }
    },
  },
}
</script>
